export default "__VITE_ASSET__20752d72__"